import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "az",
    debug: false,

    // az-AZ -> az
    load: "languageOnly",
    interpolation: { escapeValue: false },

    detection: {
      // ✅ DEPLOY üçün: navigator/htmlTag çıxarıldı
      // localStorage yoxdursa -> fallbackLng ("az") işləyəcək
      order: ["localStorage", "cookie", "querystring", "path", "subdomain"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
      checkWhitelist: true,
    },

    supportedLngs: ["az", "en", "ru"],
    nonExplicitSupportedLngs: true,

    resources: {
      az: {
        translation: {
          home: "Ana səhifə",
          about: "Haqqımızda",
          products: "Məhsullar",
          research: "Tədqiqat",
          blog: "Blog / Xəbərlər",
          contact: "Əlaqə",
          float: {
            phone: "Telefon",
            contact: "Məkan",
            go_contact: "Əlaqəyə keç",
          },
          news_not_found: "Xəbər tapılmadı",
          back: "← Geri",
          news_breadcrumb: "Xəbərlər",
          details: "Ətraflı",
          blog_title: "Blog / Xəbərlər",
          blog_subtitle: "Yeniliklər, tədbirlər və elmi xəbərlər",
          search_placeholder: "Axtar...",
          read_more: "Oxu →",
          news_default: "Xəbər",
          no_news_found: "Heç bir xəbər tapılmadı.",
          show_more: "Daha çox göstər",

          // ✅ PROMO
          promo_title: "Elmi Araşdırma • Innovativ Həllər",
          promo_text:
            "Scoriva olaraq biokimya və nanotexnologiya sahəsində qabaqcıl tədqiqatlar aparır, sənaye və tibbi sektor üçün yüksək keyfiyyətli məhsullar hazırlayırıq.",
          promo_btn: "Daha ətraflı →",

          products_title: "Məhsullar",
          details_btn: "Ətraflı →",
          no_products: "Heç bir məhsul yoxdur.",
          no_image: "Şəkil yoxdur",

          news_title: "Xəbərlər",
          news_no_image: "Şəkil yoxdur",
          news_details_btn: "Ətraflı →",
          news_empty: "Xəbər yoxdur.",

          product_not_found: "Məhsul tapılmadı",
          loading: "Yüklənir...",
          price_label: "Qiymət:",
          order_btn: "Sifariş et",
          order_form_title: "Sifariş Formu",
          order_sent_ok: "Sifarişiniz uğurla göndərildi!",
          order_required:
            "Zəhmət olmasa bütün sahələri doldurun (Ad, Soyad, Email, Telefon).",
          order_send_fail: "Sifariş göndərilmədi",
          send: "Göndər",
          sending: "Göndərilir...",
          no_specs: "Xüsusiyyət (spec) əlavə edilməyib.",

          lbl_name: "Ad",
          lbl_surname: "Soyad",
          lbl_email: "Email",
          lbl_phone: "Telefon",
          lbl_note: "Qeyd",

          about_title: "Haqqımızda",
          about_subtitle: "Şirkət haqqında məlumat, missiya və dəyərlər.",
          mission: "Missiya",
          values_title: "Dəyərlər",
          about_no_content: "Mətn hələ daxil edilməyib.",
          about_no_mission: "Missiya hələ daxil edilməyib.",
          about_footer:
            "Əlavə suallar üçün {{brand}} ilə əlaqə bölməsindən bizimlə əlaqə saxlayın.",

          research_title: "Tədqiqat",
          research_subtitle:
            "Elmi məqalələr, laboratoriya nəticələri və texnologiya xülasəsi.",
          year_label: "İl:",
          collab: "Əməkdaşlıq",
          news: "Xəbərlər",

          tech_title: "Texnologiya",
          process_hint: "Proses mərhələləri",

          process_1_t: "Toplanma",
          process_1_d:
            "Nümunələrin standart protokolla toplanması və qeydiyyatı.",
          process_2_t: "Stabilizasiya",
          process_2_d:
            "Aktiv komponentlərin stabilliyi üçün ilkin emal mərhələsi.",
          process_3_t: "Lyophilization",
          process_3_d:
            "Qurutma və saxlanma üçün lyofilizasiya prosesi.",
          process_4_t: "QC",
          process_4_d:
            "Parametrlərin yoxlanması: nəmlik, profil, uyğunluq və s.",
          process_5_t: "COA / Sertifikat",
          process_5_d:
            "Partiya üzrə sənədləşmə və izlənəbilənlik təminatı.",
          process_6_t: "Çatdırılma",
          process_6_d:
            "Təhlükəsiz qablaşdırma və soyuq zəncir logistika.",

          contact_title: "Əlaqə",
          contact_subtitle: "Əlaqə forması və WhatsApp linki.",
          contact_send_title: "Mesaj göndər",
          contact_sent_ok: "Mesaj göndərildi!",
          contact_btn_send: "Göndər",
          contact_btn_sending: "Göndərilir...",
          contact_btn_whatsapp: "WhatsApp ilə yaz",
          contact_label_name: "Ad Soyad",
          contact_label_email: "E-poçt",
          contact_label_message: "Mesajınız",
          contact_ph_name: "Ad Soyad",
          contact_ph_email: "name@example.com",
          contact_ph_message: "Mesajınızı yazın...",
          contact_err_name: "Zəhmət olmasa adınızı daxil edin.",
          contact_err_email: "Zəhmət olmasa e-poçtu daxil edin.",
          contact_err_email_valid:
            "Zəhmət olmasa düzgün e-poçt daxil edin.",
          contact_err_message: "Zəhmət olmasa mesaj yazın.",
          contact_err_send_fail: "Göndərilmədi",
          contact_info_title: "Əlaqə məlumatları",
          contact_phone: "Telefon:",
          contact_address: "Ünvan:",
          contact_email: "E-poçt:",

          tech_note:
            "Bu axın standartlaşdırılıb və batch izlənəbilənliyi ilə idarə olunur.",

          footer: {
            tagline: "Yenilikçi kimyəvi həllər və elmi tədqiqatlar.",
            pages: "Səhifələr",
            contact: "Əlaqə",
            baku: "Naxçıvan, Azərbaycan",
            rights: "Bütün hüquqlar qorunur.",
          },
        },
      },

      en: {
        translation: {
          home: "Home",
          about: "About us",
          products: "Products",
          research: "Research",
          blog: "Blog / News",
          contact: "Contact",
          news_not_found: "News not found",
          back: "← Back",
          news_breadcrumb: "News",
          details: "Details",
          blog_title: "Blog / News",
          blog_subtitle: "Updates, events, and scientific news",
          search_placeholder: "Search...",
          read_more: "Read →",
          news_default: "News",
          float: {
            phone: "Phone",
            contact: "Contact",
            go_contact: "Go to contact",
          },
          no_news_found: "No news found.",
          show_more: "Show more",

          // ✅ PROMO
          promo_title: "Scientific Research • Innovative Solutions",
          promo_text:
            "At Scoriva, we conduct advanced research in biochemistry and nanotechnology and develop high-quality products for the industrial and medical sectors.",
          promo_btn: "Learn more →",

          products_title: "Products",
          details_btn: "Details →",
          no_products: "No products available.",
          no_image: "No image",

          news_title: "News",
          news_no_image: "No image",
          news_details_btn: "Details →",
          news_empty: "No news available.",

          product_not_found: "Product not found",
          loading: "Loading...",
          price_label: "Price:",
          order_btn: "Order",
          order_form_title: "Order Form",
          order_sent_ok: "Your order has been sent successfully!",
          order_required:
            "Please fill all required fields (Name, Surname, Email, Phone).",
          order_send_fail: "Order was not sent",
          send: "Send",
          sending: "Sending...",
          no_specs: "No specs added.",

          lbl_name: "Name",
          lbl_surname: "Surname",
          lbl_email: "Email",
          lbl_phone: "Phone",
          lbl_note: "Note",

          about_title: "About Us",
          about_subtitle: "Company info, mission, and values.",
          mission: "Mission",
          values_title: "Values",
          about_no_content: "No content yet.",
          about_no_mission: "No mission yet.",
          about_footer:
            "For further questions, please contact us via the {{brand}} contact section.",

          research_title: "Research",
          research_subtitle:
            "Scientific articles, lab results, and technology overview.",
          year_label: "Year:",
          collab: "Collaboration",
          news: "News",

          tech_title: "Technology",
          process_hint: "Process stages",

          process_1_t: "Collection",
          process_1_d:
            "Sample collection and registration using a standard protocol.",
          process_2_t: "Stabilization",
          process_2_d:
            "Initial processing to ensure stability of active components.",
          process_3_t: "Lyophilization",
          process_3_d:
            "Freeze-drying process for storage and preservation.",
          process_4_t: "QC",
          process_4_d:
            "Parameter checks: moisture, profile, compliance, etc.",
          process_5_t: "COA / Certificate",
          process_5_d:
            "Batch documentation and traceability assurance.",
          process_6_t: "Delivery",
          process_6_d:
            "Secure packaging and cold-chain logistics.",

          contact_title: "Contact",
          contact_subtitle: "Contact form and WhatsApp link.",
          contact_send_title: "Send a message",
          contact_sent_ok: "Message sent successfully!",
          contact_btn_send: "Send",
          contact_btn_sending: "Sending...",
          contact_btn_whatsapp: "Write on WhatsApp",
          contact_label_name: "Full name",
          contact_label_email: "Email",
          contact_label_message: "Your message",
          contact_ph_name: "Full name",
          contact_ph_email: "name@example.com",
          contact_ph_message: "Write your message...",
          contact_err_name: "Please enter your name.",
          contact_err_email: "Please enter your email.",
          contact_err_email_valid: "Please enter a valid email.",
          contact_err_message: "Please write a message.",
          contact_err_send_fail: "Not sent",
          contact_info_title: "Contact details",
          contact_phone: "Phone:",
          contact_address: "Address:",
          contact_email: "Email:",

          tech_note:
            "This flow is standardized and managed with batch traceability.",

          footer: {
            tagline: "Innovative chemical solutions and scientific research.",
            pages: "Pages",
            contact: "Contact",
            baku: "Nakhchivan, Azerbaijan",
            rights: "All rights reserved.",
          },
        },
      },

      ru: {
        translation: {
          home: "Главная",
          about: "О нас",
          products: "Продукты",
          research: "Исследования",
          blog: "Блог / Новости",
          contact: "Контакт",
          news_not_found: "Новость не найдена",
          back: "← Назад",
          news_breadcrumb: "Новости",
          details: "Подробнее",
          blog_title: "Блог / Новости",
          blog_subtitle: "Обновления, события и научные новости",
          search_placeholder: "Поиск...",
          read_more: "Читать →",
          news_default: "Новость",
          no_news_found: "Новости не найдены.",
          show_more: "Показать больше",

          // ✅ PROMO
          promo_title: "Научные исследования • Инновационные решения",
          promo_text:
            "В Scoriva мы проводим передовые исследования в области биохимии и нанотехнологий и разрабатываем высококачественные продукты для промышленного и медицинского секторов.",
          promo_btn: "Подробнее →",

          products_title: "Продукция",
          details_btn: "Подробнее →",
          no_products: "Нет товаров.",
          no_image: "Нет изображения",

          news_title: "Новости",
          news_no_image: "Нет изображения",
          news_details_btn: "Подробнее →",
          news_empty: "Нет новостей.",

          product_not_found: "Товар не найден",
          loading: "Загрузка...",
          price_label: "Цена:",
          order_btn: "Заказать",
          order_form_title: "Форма заказа",
          order_sent_ok: "Ваш заказ успешно отправлен!",
          order_required:
            "Пожалуйста, заполните обязательные поля (Имя, Фамилия, Email, Телефон).",
          order_send_fail: "Заказ не отправлен",
          send: "Отправить",
          sending: "Отправка...",
          no_specs: "Характеристики не добавлены.",

          lbl_name: "Имя",
          lbl_surname: "Фамилия",
          lbl_email: "Email",
          lbl_phone: "Телефон",
          lbl_note: "Примечание",

          about_title: "О нас",
          about_subtitle: "Информация о компании, миссия и ценности.",
          mission: "Миссия",
          values_title: "Ценности",
          about_no_content: "Пока нет текста.",
          about_no_mission: "Пока нет миссии.",
          about_footer:
            "По дополнительным вопросам свяжитесь с нами через раздел контактов {{brand}}.",

          research_title: "Исследования",
          research_subtitle:
            "Научные статьи, результаты лаборатории и обзор технологий.",
          year_label: "Год:",
          collab: "Сотрудничество",
          news: "Новости",

          tech_title: "Технология",
          process_hint: "Этапы процесса",

          process_1_t: "Сбор",
          process_1_d:
            "Сбор и регистрация образцов по стандартному протоколу.",
          process_2_t: "Стабилизация",
          process_2_d:
            "Первичная обработка для стабильности активных компонентов.",
          process_3_t: "Лиофилизация",
          process_3_d:
            "Процесс лиофилизации для хранения и сохранности.",
          process_4_t: "QC",
          process_4_d:
            "Проверка параметров: влажность, профиль, соответствие и т.д.",
          process_5_t: "COA / Сертификат",
          process_5_d:
            "Документирование партии и обеспечение прослеживаемости.",
          process_6_t: "Доставка",
          process_6_d:
            "Безопасная упаковка и логистика холодовой цепи.",

          contact_title: "Контакты",
          contact_subtitle: "Форма связи и ссылка WhatsApp.",
          contact_send_title: "Отправить сообщение",
          contact_sent_ok: "Сообщение успешно отправлено!",
          contact_btn_send: "Отправить",
          contact_btn_sending: "Отправка...",
          contact_btn_whatsapp: "Написать в WhatsApp",
          contact_label_name: "Имя и фамилия",
          contact_label_email: "Email",
          contact_label_message: "Ваше сообщение",
          contact_ph_name: "Имя и фамилия",
          contact_ph_email: "name@example.com",
          contact_ph_message: "Напишите сообщение...",
          contact_err_name: "Пожалуйста, введите имя.",
          contact_err_email: "Пожалуйста, введите email.",
          contact_err_email_valid: "Пожалуйста, введите корректный email.",
          contact_err_message: "Пожалуйста, напишите сообщение.",
          contact_err_send_fail: "Не отправлено",
          contact_info_title: "Контактная информация",
          contact_phone: "Телефон:",
          contact_address: "Адрес:",
          contact_email: "Электронная почта:",
          float: {
            phone: "Телефон",
            contact: "Местоположение",
            go_contact: "Перейти к контактам",
          },
          tech_note:
            "Этот процесс стандартизирован и управляется с прослеживаемостью партий.",

          footer: {
            tagline: "Инновационные химические решения и научные исследования.",
            pages: "Страницы",
            contact: "Контакт",
            baku: "Нахчыван, Азербайджан",
            rights: "Все права защищены.",
          },
        },
      },
    },
  });

export default i18n;
